import * as React from 'react';
import * as styles from './styles.css';
import { DropdownPopover, Outside } from '@cian/ui-kit';
import cn from 'classnames';

import { SearchTextHistoryItem } from '../SearchTextHistoryItem';
import { ISearchTextHistoryProps } from './types';

export const SearchTextHistoryDesktop: React.FC<ISearchTextHistoryProps> = props => {
  return (
    <DropdownPopover
      open={props.isOpen}
      content={
        <Outside onOutside={props.onOutsideHistoryListClick}>
          <div className={cn(styles['container'], styles['container-desktop'])}>
            {props.searchHistoryList.map((el, i) => (
              <SearchTextHistoryItem key={i} onClick={() => props.onHistoryItemClick(el)}>
                {el}
              </SearchTextHistoryItem>
            ))}
          </div>
        </Outside>
      }
      flip={false}
      sameWidth={'width'}
    >
      {props.children}
    </DropdownPopover>
  );
};

SearchTextHistoryDesktop.displayName = 'SearchTextHistoryDesktop';
